var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#637381",
    d: "M10.186 16c0-.65.11-1.272.307-1.856L7.049 11.57A9.8 9.8 0 0 0 6 16a9.8 9.8 0 0 0 1.048 4.427l3.442-2.579A5.8 5.8 0 0 1 10.186 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M16.233 10.09A6 6 0 0 1 20 11.41l2.977-2.91C21.163 6.955 18.837 6 16.233 6c-4.044 0-7.52 2.263-9.184 5.57l3.444 2.574c.793-2.358 3.055-4.053 5.74-4.053"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M16.233 21.91c-2.685 0-4.946-1.696-5.74-4.054L7.049 20.43C8.713 23.738 12.19 26 16.233 26c2.495 0 4.878-.867 6.666-2.492l-3.268-2.473c-.923.568-2.084.874-3.398.874"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M26 16c0-.59-.093-1.227-.233-1.818h-9.534v3.864h5.488a4.5 4.5 0 0 1-2.09 2.989l3.268 2.473C24.78 21.8 26 19.26 26 16"
  })));
};
export default SvgGoogle;